import PropTypes from 'prop-types';
import React from 'react';

import NewCollectionDialog from './new_collection_dialog.jsx';
import CopyMaterialsDialog from './copy_materials_dialog.jsx';
import UploadMaterial from './upload_material_dialog.jsx';
import LinkDialog from './link_dialog';

import connect from './connect';
import { routeToSection, routeToTerm, routeToHome } from '../actions/route';

const ManageContent = props => {
    const { termId, sectionId, manage } = props.params;
    const Dialog = ManageContent.dialogs[manage];
    const onClose = () => {
        termId
            ? props.routeToTerm({ termId })
            : sectionId
            ? props.routeToSection({ sectionId })
            : props.routeToHome();
    };
    return Dialog ? <Dialog {...{ sectionId, termId, onClose }} /> : null;
};
ManageContent.propTypes = {
    params: PropTypes.object,
    routeToTerm: PropTypes.func.isRequired,
    routeToSection: PropTypes.func.isRequired,
    routeToHome: PropTypes.func.isRequired,
    termId: PropTypes.number,
    sectionId: PropTypes.number,
};
ManageContent.dialogs = {
    collection: NewCollectionDialog,
    'copy-materials': CopyMaterialsDialog,
    upload: UploadMaterial,
    link: LinkDialog,
};
export default connect(
    null,
    {
        routeToTerm,
        routeToSection,
        routeToHome,
    }
)(ManageContent);



// WEBPACK FOOTER //
// ./src/components/manage_content.jsx